import { http_client } from "@/plugins/http_client";

const url = "/api/v1/productos";
const get = async (params = {}) => await http_client(url, params, "get");
const getTemplate = async (params = {}) =>
  await http_client(`${url}/descargar-plantilla`, params, "get");
const getFiltro = async (params = {}) =>
  await http_client(`${url}/simplificado`, params, "get");
const store = async (body) => await http_client(`${url}/crear`, body, "post");
const load = async (body) =>
  await http_client(`${url}/cargar-productos`, body, "post");
const getById = async (id) => await http_client(`${url}/ver/${id}`);
const update = async (id, body) =>
  await http_client(`${url}/actualizar/${id}`, body, "post");
const eliminar = async (id, body) =>
  await http_client(`${url}/eliminar/${id}`, body, "delete");
const getImage = async (id, body) => await http_client(`${url}/ver-imagen/${id}`, body, "get");

export default {
  get,
  getTemplate,
  getFiltro,
  store,
  load,
  getById,
  update,
  eliminar,
  getImage,
};
